import React from "react";
import { sliderData } from "../helper/Helper";
function Slider() {
  return (
    <>
      <div className="bg-[#013F8A] w-full py-5 md:py-8 xl:py-10 2xl:py-11 -mt-2 lg:-mt-3 relative z-10">
        <marquee behavior="" direction="left">
          <div className="flex gap-4 sm:gap-6 xl:gap-8 items-center">
            {sliderData.map((item, index) => (
              <img key={index} src={item.path} alt="img" className="" />
            ))}
          </div>
        </marquee>
      </div>
    </>
  );
}

export default Slider;
